import { useTranslate } from 'ra-core'
import * as React from 'react'
import { TextInput } from 'react-admin'

import { validateEmail } from '../../utils/validators'

const EmailInput = ({ disabled, defaultValue }) => {
  const translate = useTranslate()
  return (
    <TextInput
      autoFocus
      defaultValue={defaultValue}
      source="username"
      label={translate('mymove.email')}
      autoComplete="email"
      sx={{ width: '100%', margin: '0' }}
      disabled={disabled}
      validate={validateEmail()}
      fullWidth
      variant="standard"
    />
  )
}

export default EmailInput
